import ErrorManager from '@/common/utils/ErrorManager';
import { sortValue } from '@/models/SortType';
import { ERROR } from '@/modules/ErrorToaster/store/mutation-types';
import { RootState } from '@/plugins/store';
import { ActionTree } from 'vuex';
import RapportASignerService, { FilterInterventions } from '../services/RapportASignerService';
import { RapportASignerActions, RapportASignerActionsTypes } from './action-types';
import { RAPPORTS_A_SIGNER } from './mutation-types';
import { RapportASignerState } from './state';

export const actions: ActionTree<RapportASignerState, RootState> = {
    async [RapportASignerActions.GET_RAPPORTS_INTERVENTIONS](
        { commit }: RapportASignerActionsTypes,
        payload: FilterInterventions
    ) {
        commit(RAPPORTS_A_SIGNER.SET_PAGE, payload.page);
        commit(RAPPORTS_A_SIGNER.SET_ERROR, undefined);
        commit(RAPPORTS_A_SIGNER.SET_RAPPORTS_A_SIGNER_IS_LOADING, true);
        try {
            const response = await RapportASignerService.getRapportsASigner(payload);
            if (response.status === 200 && response.data !== undefined) {
                if (payload.page === 0) {
                    commit(RAPPORTS_A_SIGNER.SET_ITEMS, response.data);
                    commit(RAPPORTS_A_SIGNER.SET_SCROLL, 0);
                    commit(RAPPORTS_A_SIGNER.SET_NB_OF_PAGES, response.headers.pages);
                    commit(RAPPORTS_A_SIGNER.SET_COUNT, response.headers.count);
                } else {
                    commit(RAPPORTS_A_SIGNER.ADD_ITEMS, response.data);
                }
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(RAPPORTS_A_SIGNER.SET_RAPPORTS_A_SIGNER_IS_LOADING, false);
        } catch (error) {
            commit(RAPPORTS_A_SIGNER.SET_RAPPORTS_A_SIGNER_IS_LOADING, false);
            commit(RAPPORTS_A_SIGNER.SET_ERROR, error);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    },
    async [RapportASignerActions.NAV_FILTER]({ commit }: RapportASignerActionsTypes, etats?: string[]) {
        commit(RAPPORTS_A_SIGNER.SET_FILTER_SITE, []);
        commit(RAPPORTS_A_SIGNER.RESET_ITEMS);
        this.dispatch(`rapportASignerState/${RapportASignerActions.GET_RAPPORTS_INTERVENTIONS}`, {
            page: 0,
            etats,
            sort:
                this.state.rapportASignerState.sort &&
                sortValue(
                    this.state.rapportASignerState.sort?.sortData,
                    this.state.rapportASignerState.sort?.sortStatus
                ),
            dateDebutPeriodeRechercheParDate: this.state.rapportASignerState.filterPredictedDateFrom,
            dateFinPeriodeRechercheParDate: this.state.rapportASignerState.filterPredictedDateTo,
        });
    },
    async [RapportASignerActions.GET_XLS_RAPPORTS_A_SIGNER]({ commit }: RapportASignerActionsTypes, payload: FilterInterventions) {
        commit(RAPPORTS_A_SIGNER.SET_EXPORT_XLS_IS_LOADING, true);
        try {
            const response = await RapportASignerService.getExportXlsRapport(payload);
            if (response.status === 200 && response.data !== undefined) {
                const blob = new Blob([response.data],{ type: response.headers['content-type'] });
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = 'export_rapports.xlsx';
                link.click();
                URL.revokeObjectURL(link.href);
            } else {
                commit(
                    `errorToaster/${ERROR.SET_MESSAGE}`,
                    await ErrorManager.processErrorCustomMessage(response.status, 'app.error.undefined'),
                    { root: true }
                );
            }
            commit(RAPPORTS_A_SIGNER.SET_EXPORT_XLS_IS_LOADING, false);
        } catch (error) {
            commit(RAPPORTS_A_SIGNER.SET_EXPORT_XLS_IS_LOADING, false);
            commit(`errorToaster/${ERROR.SET_MESSAGE}`, await ErrorManager.processError(error), { root: true });
        }
    }

};
